module.exports = "/_next/static/images/icon_email-84b0be295da99103872159f0fcd8f25b.svg";